if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){
    
    if($('.heat-map__map').length > 0){
        const point_first = document.querySelectorAll('.heat-map__point'); point_first[0].click();

        const items_map = document.querySelectorAll('.heat-map__point');
        $('.heat-map__list-items ul li').mouseover(function(){
            for(let z = 0; z<items_map.length; z++){
                if(this.dataset.tag == items_map[z].dataset.tag){
                    items_map[z].classList.add('active2');
                }else{
                    items_map[z].classList.remove('active2');
                }
            }
        })        
    }
    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

})();
